<div class="min-h-[100dvh] bg-[#fcfaf7] flex flex-col font-sans text-[#1f1b16]">
  @if (loading()) {
    <div class="flex min-h-[100dvh] items-center justify-center">
      <p class="text-sm font-medium text-[#3a332c]/50">Cargando cuenta...</p>
    </div>
  } @else if (waiting()) {
    <div class="flex min-h-[100dvh] flex-col bg-[#f6f1eb]">
      <header class="bg-[#fcfaf7] border-b border-black/5">
        <div class="mx-auto max-w-2xl px-4 py-4 text-center">
          <img
            src="https://res.cloudinary.com/dgjd3ybs1/image/upload/v1772476007/logo-dinno-chef_ybshqf.png"
            alt="Dinno"
            class="mx-auto h-20 w-20 object-contain"
          />

          <h2 class="mt-4 text-2xl font-black text-[#1f1b16]">Listo, {{ participantName }}!</h2>

          <p class="mt-2 text-sm leading-relaxed text-[#3a332c]/65">
            Tu selección ya fue enviada. Ahora el anfitrión va a confirmar la división.
          </p>

          <div class="mt-5 flex justify-center gap-2">
            <span class="h-2.5 w-2.5 rounded-full bg-orange-300 animate-bounce"></span>
            <span
              class="h-2.5 w-2.5 rounded-full bg-orange-300 animate-bounce [animation-delay:120ms]"
            ></span>
            <span
              class="h-2.5 w-2.5 rounded-full bg-orange-300 animate-bounce [animation-delay:240ms]"
            ></span>
          </div>
        </div>
      </header>

      <main class="mx-auto w-full max-w-2xl flex-1 px-4 py-4">
        <div class="mb-3 flex items-center justify-between">
          <h3 class="text-sm font-black text-[#1f1b16]">Lo que marcaste</h3>

          <span class="text-xs font-semibold text-[#3a332c]/50">
            {{ submittedItems().length }} ítem{{ submittedItems().length === 1 ? '' : 's' }}
          </span>
        </div>

        <section>
          <div class="space-y-3">
            @for (item of submittedItems(); track item.itemId) {
              <div>
                <app-participant-submitted-item-card
                  [item]="item"
                  [draft]="getDraftForItem(item.itemId)"
                />
              </div>
            }
          </div>
        </section>
      </main>
    </div>
  } @else {
    <header class="sticky top-0 z-20 bg-[#fcfaf7]/95 backdrop-blur-md border-b border-black/5">
      <div class="max-w-2xl mx-auto px-4 py-3">
        <p class="text-sm text-[#3a332c]/65">{{ title() }}</p>
        <h1 class="text-xl font-semibold tracking-tight text-[#1f1b16]">
          Hola {{ participantName }}, ¿qué consumiste?
        </h1>
      </div>
    </header>

    <main class="flex-1 bg-[#f6f1eb] w-full max-w-2xl mx-auto px-4 py-4 space-y-4">
      @for (item of items(); track item.itemId) {
        <section>
          <app-participant-item-card
            [item]="item"
            [draft]="getDraftForItem(item.itemId)"
            (toggleSelected)="toggleItem(item.itemId)"
            (modeChange)="updateMode(item.itemId, $event)"
            (equalShareScopeChange)="updateEqualShareScope(item.itemId, $event)"
            (equalShareQuantityChange)="updateEqualShareQuantity(item.itemId, $event)"
            (quantityChange)="updateQuantity(item.itemId, $event)"
            (unresolvedClick)="markUnresolved(item.itemId)"
          />
        </section>
      }
    </main>

    <app-participant-item-groups-modal
      [isOpen]="unresolvedModalOpen()"
      [itemQuantity]="unresolvedItem()?.quantity ?? 1"
      [itemDescription]="unresolvedItem()?.description ?? ''"
      [groups]="getDraftForItem(unresolvedModalItemId() ?? '').suggestedGroups"
      (canceled)="closeUnresolvedModal()"
      (confirm)="saveUnresolvedGroups($event)"
    />

    <footer class="sticky bottom-0 bg-[#fcfaf7] border-t border-black/5 px-4 py-4">
      <div class="max-w-2xl mx-auto">
        <button
          type="button"
          (click)="submitSelection()"
          [disabled]="!hasSubmittableSelection() || saving() || alreadySubmitted()"
          class="w-full rounded-2xl py-4 font-bold shadow-md transition-all active:scale-[0.98]"
          [class.bg-gradient-to-r]="selectedConsumptionsCount() > 0 && !saving()"
          [class.from-orange-500]="selectedConsumptionsCount() > 0 && !saving()"
          [class.to-amber-500]="selectedConsumptionsCount() > 0 && !saving()"
          [class.text-white]="selectedConsumptionsCount() > 0 && !saving()"
          [class.bg-[#f4b290]]="selectedConsumptionsCount() === 0 || saving()"
          [class.text-white/80]="selectedConsumptionsCount() === 0 || saving()"
        >
          {{
            saving() ? 'Enviando...' : 'Enviar selección (' + selectedConsumptionsCount() + ') →'
          }}
        </button>
      </div>
    </footer>
  }
</div>
